import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'tc-setup-2fa-step-1',
  templateUrl: './setup-2fa-step1.component.html',
  styleUrls: ['../base/two-factor-authentication.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Setup2FAStep1Component {}
